import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause, ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { PublishedConnectionTables } from '~src/publishedConnection/components/tables/resources/PublishedConnectionTables';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { PublishedConnectionTableContentType } from '~src/ts/models/ContentTypes';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const PublishedConnectionTableDefinition: ExplorableItemDefinition = {
  itemType: 'publishedConnectionTable',
  pluralName: Messages.publishedConnectionTables,
  singularName: Messages.publishedConnectionTable,
  emptyStateMessage: Messages.publishedConnectionTablesEmpty,
  contentFilterKeys: PublishedConnectionTableContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: null,
  listViewIconUrl: '',
  filterClause: ServerFilterClauses.ContentType(['publishedConnectionTable']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return PublishedConnectionTables.all().withExtraParams(PublishedConnectionTableContentType.extraQueryParams);
  },
  getContentInfo: () => {
    throw new Error('getContentInfo is not implemented for publishedConnectionTable');
  },
  supportedDisplayModes: ['list']
};
